export default (state = "", action) => {
  if (action.type === "INPUT_USERNAME") {
    return action.payload;
  }
  return state;
};
